import { Box, BoxProps, HStack, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import { BiLinkExternal } from 'react-icons/bi'

interface Props extends BoxProps {
  href: string
  hideIcon?: boolean
  children?: React.ReactNode
}
export default function ExternalLink({ href, hideIcon = false, children, ...restProps }: Props) {
  return (
    <Box as="a" href={href} target="_blank" wordBreak="break-all" rel="noopener noreferrer" {...restProps}>
      {hideIcon && <Box w="100%">{children}</Box>}
      {!hideIcon && (
        <HStack>
          <Text>{children}</Text>
          <Box>
            <BiLinkExternal size="22px" />
          </Box>
        </HStack>
      )}
    </Box>
  )
}
